import { DocumentHistoryModule } from './../documentHistory/documentHistory.module';
import { InputTextareaModule } from 'primeng-lts/inputtextarea';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { documentViewerComponent } from './documentViewer.component';
import { DocumentFileModule } from '../documentFile/documentFile.module';
import { DossierHeaderModule } from '../../dossiers/components/dossierHeader.module';
import { FilePDFViewerModule } from '../filePDFViewer/filePDFViewer.module';
import { UserModule } from '../../user/user/user.module';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { AccordionModule } from 'primeng-lts/accordion';
import { ConfirmationService } from 'primeng-lts/api';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { DropdownModule } from 'primeng-lts/dropdown';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { PanelModule } from 'primeng-lts/panel';
import { MultiDocumentViewerComponent } from './multiDocumentViewer.component';

@NgModule({
    declarations: [documentViewerComponent, MultiDocumentViewerComponent],
    imports: [TranslateModule, CommonModule,
        FormsModule,
        RouterModule,
        WaitLoadingModule,
        DossierHeaderModule,
        DocumentFileModule,
        DynamicDialogModule,
        AccordionModule,
        FilePDFViewerModule, UserModule,
        ConfirmDialogModule,
        ScrollPanelModule,
        SubHeaderModule,
        DropdownModule,
        InputTextareaModule,
        PanelModule,
        DocumentHistoryModule
    ],
    providers: [ConfirmationService],
    exports: [documentViewerComponent, MultiDocumentViewerComponent]
})

export class DocumentViewerModule {
}
